(function($) {
  Drupal.behaviors.basic_video_carousel = {
    attach: function($this, settings) {
      $('.main-content', $this).once(function() {
        /*
         * --------------------------------------------------------------------------
         * VIDEO CAROUSEL V1.1
         * --------------------------------------------------------------------------
         * Functionality for a Continuous Carousel with the following features:
         * Allows for the addition of infinite slides.
         * Updates the contents of dummy slides accordingly.
         * Adds identifying classes to each slide for ease of reference.
         * Adds an active class to each slide for ease of visibility.
         */
        // Check for iPad.
        var isTouch = false;
        if (navigator.userAgent.match(/iPad/i) !== null) {
          isTouch = true;
          $('body').addClass('isTouch');
        }

        var autoScrollDur = 6000;
        var interval;
        var videoActive = false;

        $('.basic_video_carousel_v1').each(function() {
          var $this = $(this);
          /*
          /--------------------------------------------------------------------------
          / Strip whitespace to prevent spaces between slides.
          /--------------------------------------------------------------------------
          */
          var stripWhiteSpace = $this.find('.basic_video_carouselContainer').find('*');
          stripWhiteSpace.contents().filter(function() {
            return this.nodeType = Node.TEXT_NODE && /\S/.test(this.nodeValue) === false;
          }).remove();

          /*
          /--------------------------------------------------------------------------
          / Video Playback.
          /--------------------------------------------------------------------------
          */
          var clickPlay = $this.find('.basic_video_carousel_slide_v1 .video_content_cta');
          var clickClose = $this.find('.basic_video_carousel_slide_v1 .el_vcv1_close');

          clickPlay.on('click', function() {
            if ($this.hasClass('auto_scroll_1')) {
              clearInterval(interval);
              videoActive = true;
            }
            if ($(this).parents(':eq(1)').hasClass('overlay')) {
              $(this).closest('.basic_video_carousel_slide.active').addClass('videoOverlay');
              $('body').css({
                'overflow': 'hidden'
              });
            }
          });
          clickClose.on('click', function() {
            if ($this.hasClass('auto_scroll_1')) {
              interval = setInterval(function() {
                var thistrigger = $this.find('.basic_video_carouselnav_2');
                animateCarousel(thistrigger, 2);
              }, autoScrollDur);
              videoActive = false;
            }
            $(this).closest('.basic_video_carousel_slide.active').removeClass('videoOverlay');
            $('body').css({
              'overflow': 'visible'
            });
          });

          /*
          /--------------------------------------------------------------------------
          / Remove any content block that renders empty content
          /--------------------------------------------------------------------------
          / Normally due to mismatched revision tags.
          */
          var carouselWrapper = $this.find('.basic_video_carouselWrapper');
          var innerContent = carouselWrapper.find('.basic_video_carouselInner');
          var checkContent = innerContent.find('.node-elc-nodeblock .content');
          checkContent.each(function() {
            if ($(this).html().length === 0) {
              $(this).parent().addClass('empty_content').parent().detach().insertBefore($this);
            }
          });

          /*
          /--------------------------------------------------------------------------
          / Grab all the content and wrap in slides.
          /--------------------------------------------------------------------------
          */
          $this.find('.basic_video_carouselInner').children().wrap('<div class="basic_video_carousel_slide"></div>');

          /*
          /--------------------------------------------------------------------------
          / Calculate the number of slides.
          /--------------------------------------------------------------------------
          */
          var slideTotal = innerContent.find('.basic_video_carousel_slide').length;

          /*
          /--------------------------------------------------------------------------
          / Calculate the width of each slide according to no. of slides.
          /--------------------------------------------------------------------------
          */

          if ($this.find('.basic_video_carouselInner').children('.basic_video_carousel_slide').length > 2) {
            /*
            /--------------------------------------------------------------------------
            / Handle pagination dots.
            /--------------------------------------------------------------------------
            */
            var paginationTrue = false;
            var pagActCust = false;
            var pagActCustCol;
            var pagInactCust = false;
            var pagInactCustCol;
            if ($this.hasClass('pc_pag_1') || $this.hasClass('mob_pag_1')) {
              if ($this.attr('data-pag-active')) {
                pagActCust = true;
                pagActCustCol = $this.data('pag-active');
              }
              if ($this.attr('data-pag-inactive')) {
                pagInactCust = true;
                pagInactCustCol = $this.data('pag-inactive');
              }
              paginationTrue = true;
              var pagCount = slideTotal;
              var thisContainer = $this.find('.basic_video_carouselContainer');
              $('<div class="basic_video_carousel_pagination"></div>').insertAfter(thisContainer);
              var pagTarget = $this.find('.basic_video_carousel_pagination');
              for (var i = 1; i <= pagCount; i++) {
                pagTarget.append('<div val="' + i + '" class="basic_video_carousel_pagination_dot"></div>');
              }
              pagTarget.find('.basic_video_carousel_pagination_dot').first().addClass('selected');
              if (pagActCust) {
                pagTarget.find('.basic_video_carousel_pagination_dot').first().css('background-color', pagActCustCol);
              }
              if (pagInactCust) {
                pagTarget.find('.basic_video_carousel_pagination_dot:not(:first)').css('background-color', pagInactCustCol);
              }
              pagTarget.find('.basic_video_carousel_pagination_dot').each(function(i) {
                $(this).addClass('basic_video_carousel_pagination_dot_' + (i + 1));
                if (i + 1 === pagCount) {
                  pagTarget.addClass('basic_video_carousel_pagination_complete');
                }
              });
            }

            /*
            /--------------------------------------------------------------------------
            / Add identifying classes to the slides.
            /--------------------------------------------------------------------------
            */
            $this.find('.basic_video_carouselInner .basic_video_carousel_slide').each(function(i) {
              $(this).addClass('basic_video_carousel_slide' + (i + 1));
            });

            /*
            /--------------------------------------------------------------------------
            / Handle the placeholder slides.
            /--------------------------------------------------------------------------
            */
            var firstSlideLoc = $this.find('.basic_video_carouselInner .basic_video_carousel_slide').first();
            var lastSlideLoc = $this.find('.basic_video_carouselInner .basic_video_carousel_slide').last();

            firstSlideLoc.addClass('basic_video_carousel_slide_first active');
            firstSlideLoc.next().addClass('leftSlide');
            lastSlideLoc.addClass('basic_video_carousel_slide_last rightSlide');

            /*
            /--------------------------------------------------------------------------
            / Calculate the slide animation value.
            /--------------------------------------------------------------------------
            */
            var isAnimating, pagAnimating, goingLeft, goingRight;
            isAnimating = pagAnimating = goingLeft = goingRight = false;
            var theDirection;
            var counter = 1;
            var pagCountNum = 1;
            var slideDivide = slideTotal / slideTotal;
            var resetRight = slideTotal + 1;
            var resetLeft = slideDivide - 1;
            var counterRight = slideDivide;
            var counterLeft = slideTotal;
            var animTiming = 490;

            /*
            /--------------------------------------------------------------------------
            / Handle the Carousel animation and counter.
            /--------------------------------------------------------------------------
            / Add functions to add/remove active class.
            / Add function to switch the first/last active class.
            / Handle the pagination dots.
            / Handle the carousel animation and counters.
            / Handle rtl.
            */
            function findActive() {
              if ($this.find('.basic_video_carousel_slide.active').hasClass('basic_video_carousel_slide_last')) {
                $this.find('.basic_video_carousel_slide_first').addClass('leftSlide').siblings().removeClass('leftSlide');
                $this.find('.basic_video_carousel_slide.active').prev().addClass('rightSlide').siblings().removeClass('rightSlide');
              } else if ($this.find('.basic_video_carousel_slide.active').hasClass('basic_video_carousel_slide_first')) {
                $this.find('.basic_video_carousel_slide_last').addClass('leftSlide').siblings().removeClass('leftSlide');
                $this.find('.basic_video_carousel_slide.active').next().addClass('rightSlide').siblings().removeClass('rightSlide');
              } else {
                $this.find('.basic_video_carousel_slide.active').next().addClass('leftSlide').siblings().removeClass('leftSlide');
                $this.find('.basic_video_carousel_slide.active').prev().addClass('rightSlide').siblings().removeClass('rightSlide');
              }
            }

            function animateSlides() {
              if (goingRight === true) {
                $this.find('.basic_video_carousel_slide.leftSlide').addClass('isMoving');
                $this.find('.basic_video_carousel_slide.active').addClass('isMoving');
                $this.find('.basic_video_carousel_slide.rightSlide').addClass('isMovingBack');
              } else {
                $this.find('.basic_video_carousel_slide.rightSlide').addClass('isMoving');
                $this.find('.basic_video_carousel_slide.active').addClass('isMovingBack');
                $this.find('.basic_video_carousel_slide.leftSlide').addClass('isMovingBack');
              }
              setTimeout(function() {
                $('.isMoving').removeClass('isMoving');
                $('.isMovingBack').removeClass('isMovingBack');
              }, animTiming);
            }

            function activeNext() {
              animateSlides();
              setTimeout(function() {
                $this.find('.basic_video_carousel_slide.active').next().addClass('active').siblings().removeClass('active');
                findActive();
              }, animTiming);
            }

            function activePrev() {
              animateSlides();
              setTimeout(function() {
                $this.find('.basic_video_carousel_slide.active').prev().addClass('active').siblings().removeClass('active');
                findActive();
              }, animTiming);
            }

            function SwitchLastFirst() {
              animateSlides();
              setTimeout(function() {
                $this.find('.basic_video_carousel_slide_first').addClass('active').siblings().removeClass('active');
                $this.find('.basic_video_carousel_slide_first').next().addClass('leftSlide').siblings().removeClass('leftSlide');
                $this.find('.basic_video_carousel_slide_last').addClass('rightSlide').siblings().removeClass('rightSlide');
              }, animTiming);
            }

            function SwitchFirstLast() {
              animateSlides();
              setTimeout(function() {
                $this.find('.basic_video_carousel_slide_first').addClass('leftSlide').siblings().removeClass('leftSlide');
                $this.find('.basic_video_carousel_slide_last').prev().addClass('rightSlide').siblings().removeClass('rightSlide');
                $this.find('.basic_video_carousel_slide_last').addClass('active').siblings().removeClass('active');
              }, animTiming);
            }

            // Determine direction (RTL support)
            var isRTL = false;
            setTimeout(function() {
              if ($('.field-content').hasClass('pcl_rtl')) {
                isRTL = true;
              }
            }, 1000);

            function negDirection() {
              theDirection = '-=100%';
              counter++;
              pagCountNum++;
              goingRight = true;
              goingLeft = false;
            }

            function posDirection() {
              theDirection = '+=100%';
              counter--;
              pagCountNum--;
              goingRight = false;
              goingLeft = true;
            }

            // Timings
            var slideDuration = 700;
            var easing = 'easeOutCirc';
            var willAutoScroll = false;
            if ($this.hasClass('auto_scroll_1')) {
              willAutoScroll = true;
            }

            /*
            /--------------------------------------------------------------------------
            / Carousel Animation - Timer.
            /--------------------------------------------------------------------------
            / Set up clear/reset timer as click events to access it from
            / other templates, if required.
            */
            var clearThisTimer = $this.find('.basic_video_carousel_clear');
            var resetThisTimer = $this.find('.basic_video_carousel_reset');
            clearThisTimer.on('click', function() {
              if (willAutoScroll) {
                clearInterval(interval);
              }
            });
            resetThisTimer.on('click', function() {
              if (willAutoScroll) {
                resetTimer();
              }
            });

            /*
            /--------------------------------------------------------------------------
            / Carousel Animation - Pagination driven.
            /--------------------------------------------------------------------------
            */
            if (paginationTrue) {
              function animatePagination(pagCountNum) {
                $this.find('.basic_video_carousel_pagination_dot_' + pagCountNum).on('click', function() {
                  if (videoActive === false) {
                    if ($(this).hasClass('selected')) {
                      pagAnimating = false;
                      return;
                    } else {
                      if (pagAnimating === false) {
                        if (pagCountNum > $('.basic_video_carousel_pagination_dot.selected').attr('val')) {
                          negDirection();
                        } else {
                          posDirection();
                        }
                        clearInterval(interval);
                        pagAnimating = true;
                        if (pagActCust && !pagInactCust) {
                          $(this).addClass('selected').css('background-color', pagActCustCol).siblings().removeClass('selected').css('background-color', '');
                        } else if (pagActCust && pagInactCust) {
                          $(this).addClass('selected').css('background-color', pagActCustCol).siblings().removeClass('selected').css('background-color', pagInactCustCol);
                        } else if (pagInactCust && !pagActCust) {
                          $(this).addClass('selected').css('background-color', '').siblings().removeClass('selected').css('background-color', pagInactCustCol);
                        } else {
                          $(this).addClass('selected').siblings().removeClass('selected');
                        }
                        counter = pagCountNum;
                        pagAnimating = false;
                        resetTimer();
                        if ($this.find('.basic_video_carousel_slide' + pagCountNum).hasClass('basic_video_carousel_slide_last')) {
                          animateSlides();
                          setTimeout(function() {
                            $this.find('.basic_video_carousel_slide_first').addClass('leftSlide').siblings().removeClass('leftSlide');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).prev().addClass('rightSlide').siblings().removeClass('rightSlide');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).addClass('active').siblings().removeClass('active');
                          }, animTiming);
                        } else if ($this.find('.basic_video_carousel_slide' + pagCountNum).hasClass('basic_video_carousel_slide_first')) {
                          animateSlides();
                          setTimeout(function() {
                            $this.find('.basic_video_carousel_slide_last').addClass('rightSlide').siblings().removeClass('rightSlide');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).next().addClass('leftSlide').siblings().removeClass('leftSlide');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).addClass('active').siblings().removeClass('active');
                          }, animTiming);
                        } else {
                          animateSlides();
                          setTimeout(function() {
                            $this.find('.basic_video_carousel_slide' + pagCountNum).addClass('active').siblings().removeClass('active');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).next().addClass('leftSlide').siblings().removeClass('leftSlide');
                            $this.find('.basic_video_carousel_slide' + pagCountNum).prev().addClass('rightSlide').siblings().removeClass('rightSlide');
                          }, animTiming);
                        }
                      }
                    }
                  }
                });
              }
              for (var j = 1; j <= slideTotal; j++) {
                animatePagination(j);
              }
            }

            /*
            /--------------------------------------------------------------------------
            / Carousel Animation - Chevron driven.
            /--------------------------------------------------------------------------
            */
            function animateCarousel($this, arrowNo) {
              if (videoActive === false) {
                if (isAnimating === false) {
                  clearInterval(interval);
                  isAnimating = true;
                  if (arrowNo === 1) {
                    if (isRTL) {
                      negDirection();
                    } else {
                      posDirection();
                    }
                  } else {
                    if (isRTL) {
                      posDirection();
                    } else {
                      negDirection();
                    }
                  }
                  carouselWrapper.animate({}, slideDuration, easing, function() {
                    if (goingRight) {
                      activeNext();
                    } else if (goingLeft) {
                      activePrev();
                    }
                    if (counter === resetRight) {
                      counter = counterRight;
                      SwitchLastFirst();
                    } else if (counter === resetLeft) {
                      counter = counterLeft;
                      SwitchFirstLast();
                    }
                  }).promise().done(function() {
                    pagCountNum = counter;
                    if (pagActCust && !pagInactCust) {
                      $this.find('.basic_video_carousel_pagination_dot_' + counter).addClass('selected').css('background-color', pagActCustCol).siblings().removeClass('selected').css('background-color', '');
                    } else if (pagActCust && pagInactCust) {
                      $this.find('.basic_video_carousel_pagination_dot_' + counter).addClass('selected').css('background-color', pagActCustCol).siblings().removeClass('selected').css('background-color', pagInactCustCol);
                    } else if (pagInactCust && !pagActCust) {
                      $this.find('.basic_video_carousel_pagination_dot_' + counter).addClass('selected').css('background-color', '').siblings().removeClass('selected').css('background-color', pagInactCustCol);
                    } else {
                      $('.basic_video_carousel_pagination_dot_' + counter).addClass('selected').siblings().removeClass('selected');
                    }
                    isAnimating = false;
                    if ($('.js-basic_video_carousel_v1').hasClass('auto_scroll_1')) {
                      setTimeout(function() {
                        resetTimer();
                      }, 500);
                    }
                  });
                }
              }
            }

            $this.find('.basic_video_carouselnav_1').on('click', function() {
              animateCarousel($this, 1);
            });

            $this.find('.basic_video_carouselnav_2').on('click', function() {
              animateCarousel($this, 2);
            });

            /*
            /--------------------------------------------------------------------------
            / Set the carousel to automatically swipe if set by user.
            /--------------------------------------------------------------------------
            / Every x seconds the carousel swipes.
            */

            function resetTimer() {
              interval = setInterval(function() {
                var thistrigger = $this.find('.basic_video_carouselnav_2');
                animateCarousel(thistrigger, 2);
              }, autoScrollDur);
            }

            if (willAutoScroll) {
              resetTimer();
            }

            /*
            /--------------------------------------------------------------------------
            / Handle the Carousel animation for mobile.
            /--------------------------------------------------------------------------
            */
            function swipeEvent() {
              if ($(window).width() <= 768 || $('body').hasClass('isTouch')) {
                $this.find('.basic_video_carouselContainer').swiperight(function() {
                  $this.find('.basic_video_carouselnav_2').trigger('click');
                });
                $this.find('.basic_video_carouselContainer').swipeleft(function() {
                  $this.find('.basic_video_carouselnav_1').trigger('click');
                });
              } else {
                $this.find('.basic_video_carouselContainer').off('swiperight swipeleft');
                return;
              }
            }

            var resizeTimer;
            $(window).on('resize', function() {
              // Throttle/ debounce resize event:
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(function() {
                // Resizing has "stopped"
                swipeEvent();
              }, 10);
            });
            swipeEvent();
          } else if ($this.find('.basic_video_carouselInner').children('.basic_video_carousel_slide').length === 2) {
            $this.find('.basic_video_carouselnav').addClass('carousel_elem_hide');
            $('.basic_video_carousel_v1').addClass('two_slides');
          } else {
            $this.find('.basic_video_carouselnav').addClass('carousel_elem_hide');
            $('.basic_video_carousel_v1').addClass('one_slide');
          }
        });
      });
    }
  };
})(jQuery);
